import React from "react";
import DateHelper from "../DateHelper/DateHelper";
import BookingAccommodationsTab from "./tabs/BookingAccommodationsTab";
import BookingAddOnsTab from "./tabs/BookingAddOnsTab";
import BookingTotalTab from "./tabs/BookingTotalTab";
import BookingVouchersTab from "./tabs/BookingVouchersTab";
import BookingFlowSuccess from "./BookingFlowSuccess";
import BookingSignInSignUpModal from "./BookingSignInSignUpModal";
import BookingCheckAvailabilityModal from "./BookingCheckAvailabilityModal";
import BookingWizard from "./BookingWizard";
import ModalWarning from "../ModalWarning/ModalWarning";
import SessionTimoutWarning from "./SessionTimoutWarning";
import ObjectHelper from "../ObjectHelper/ObjectHelper";
import ReactPortalsRoot from "../ReactPortalsRoot/ReactPortalsRoot";
import BookingFlowBrandingFooter from './BookingFlowBrandingFooter'
import {
  isAfter,
  addDays,
  differenceInDays,
  differenceInMilliseconds,
} from "date-fns";
import ReservationBuilderHelper from "../ReservationBuilder/ReservationBuilderHelper";

const _cloneDeep = require("lodash/cloneDeep");

export default class BookingFlow extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      account: this.props.account,
      property: this.props.property,
      add_on_products: [],
      accept_terms: false,
      accept_communication_terms: true,
      source_type: this.props.source_type || "channel",
      source_id: this.props.source_id,
      source_name: this.props.source_name,
      marketing_opt_in: true,
      card_id: null,
      check_availability_visible: false,
      guestSectionValid: false,
      guestSectionCustomerForm: null,
      signInSignUpModalCustomerForm: null,
      validPayment: false,
      currency: {
        id: "USD|$|1",
        name: "United States Dollar",
        iso_code: "USD",
        symbol: "$",
        exchange_rate: 1,
      },
      date_format: this.props.date_format,
      errors: [],
      paymentErrors: [],
      guest_information: {},
      guest_confirmed: this.props.customer_confirmed,
      guests: this.getDefaultGuestTypes(),
      loading: false,
      opened: false,
      payment_method: { save_card: true },
      add_ons: [],
      add_ons_reservation_segment_id: "",
      promo_code: "",
      reservation: {},
      reservation_segments: [],
      reservation_segment_ids: [],
      room_types: this.props.room_types,
      modalVisible: false,
      session_start: new Date(),
      session_timeout: this.props.session_timeout_duration * 1000,
      session_timeout_grace_period: this.props.session_grace_period * 1000,
      session_timeout_enabled: this.props.session_timeout_enabled,
      session_timeout_warning_visible: false,
      session_expired_warning_visible: false,
      sign_in_information: {},
      sign_in_sign_up_visible: false,
      end_date: DateHelper.parseRawDate(this.props.end_date),
      start_date: DateHelper.parseRawDate(this.props.start_date),
      step: "accommodations",
      taken_room_groups: [],
      form_fields: this.props.form_fields || [],
      substep: null,
      rating_answers: this.props.rating_answers || [],
      emoji_answers: this.props.emoji_answers || [],
      reservationNotes: "",
      no_availability_text: this.props.no_availability_text,
      customerFormFieldsValid: this.props.form_fields.length ? false : true,
      voucherInputValue: "",
      voucher: null,
      vouchers: [],
      displayVoucherInput: false,
    };

    // load dates from sessionStorage
    if (this.storageAvailable("sessionStorage")) {
      var dates = sessionStorage.getItem("dates")
        ? JSON.parse(sessionStorage.getItem("dates"))
        : null;
      if ((!this.state.start_date || !this.state.end_date) && dates) {
        this.state.start_date = new Date(dates.start_date);
        this.state.end_date = new Date(dates.end_date);
      }

      // load reservation from sessionStorage
      var reservation = sessionStorage.getItem("reservation")
        ? JSON.parse(sessionStorage.getItem("reservation"))
        : null;
      if (reservation) {
        this.state.reservation = reservation;
      }

      // load reservation segments from sessionStorage
      var reservation_segments = sessionStorage.getItem("reservation_segments")
        ? JSON.parse(sessionStorage.getItem("reservation_segments"))
        : null;
      if (reservation_segments && reservation_segments.length > 0) {
        for (var i = 0, ilen = reservation_segments.length; i < ilen; i++) {
          reservation_segments[i].start_date = new Date(
            reservation_segments[i].start_date
          );
          reservation_segments[i].end_date = new Date(
            reservation_segments[i].end_date
          );
        }
        this.state.reservation_segments = reservation_segments;
        this.state.step = "total";
      }

      // load guests from sessionStorage
      var guests = sessionStorage.getItem("guests")
        ? JSON.parse(sessionStorage.getItem("guests"))
        : null;
      if (guests) {
        this.state.guests = guests;
      }

      // load add-ons from sessionStorage
      var add_ons = sessionStorage.getItem("add_ons") || null;
      if (add_ons) {
        this.state.add_ons = JSON.parse(add_ons);
      }

      var add_ons_reservation_segment_id =
        sessionStorage.getItem("add_ons_reservation_segment_id") || null;
      if (add_ons_reservation_segment_id) {
        this.state.add_ons_reservation_segment_id =
          add_ons_reservation_segment_id;
      }

      // load new vouchers from sessionStorage
      var vouchers = sessionStorage.getItem("vouchers") || null;
      if (vouchers) {
        this.state.vouchers = JSON.parse(vouchers);
        this.state.vouchers.map((voucher) => {
          voucher.delivery_date = new Date(voucher.delivery_date);
        });

        if (this.state.vouchers.length) {
          this.state.step = "total";
        }
      }
    }

    I18n.locale = this.props.locale;

    this.bookingFlowRef = React.createRef();

    this.loadRoomTypes = this.loadRoomTypes.bind(this);
    this.onAddReservationSegment = this.onAddReservationSegment.bind(this);
    this.goToAccommodationsStep = this.goToAccommodationsStep.bind(this);
    this.onAddReservationSegments = this.onAddReservationSegments.bind(this);
    this.onBookNow = this.onBookNow.bind(this);
    this.onChange = this.onChange.bind(this);
    this.onChangeCurrency = this.onChangeCurrency.bind(this);
    this.onChangeCustomerForm = this.onChangeCustomerForm.bind(this);
    this.onChangeDates = this.onChangeDates.bind(this);
    this.onChangeStartDate = this.onChangeStartDate.bind(this);
    this.onChangeGuestInformation = this.onChangeGuestInformation.bind(this);
    this.onChangeGuestSectionValid = this.onChangeGuestSectionValid.bind(this);
    this.onChangeCustomerFormFieldsValid =
      this.onChangeCustomerFormFieldsValid.bind(this);
    this.onChangeGuestTypeCount = this.onChangeGuestTypeCount.bind(this);
    this.onChangePaymentMethod = this.onChangePaymentMethod.bind(this);
    this.onChangeAddOns = this.onChangeAddOns.bind(this);
    this.onChangeSignInInformation = this.onChangeSignInInformation.bind(this);
    this.onChangeStep = this.onChangeStep.bind(this);
    this.onChangeFormField = this.onChangeFormField.bind(this);
    this.onClearPaymentMethod = this.onClearPaymentMethod.bind(this);
    this.onForgotPassword = this.onForgotPassword.bind(this);
    this.onModalVisible = this.onModalVisible.bind(this);
    this.onRemoveReservationSegment =
      this.onRemoveReservationSegment.bind(this);
    this.onSetErrors = this.onSetErrors.bind(this);
    this.onSetGuestInformation = this.onSetGuestInformation.bind(this);
    this.onSetCardId = this.onSetCardId.bind(this);
    this.onSignOut = this.onSignOut.bind(this);
    this.onSubmitPromoCode = this.onSubmitPromoCode.bind(this);
    this.onToggleSignInSignUp = this.onToggleSignInSignUp.bind(this);
    this.onToggleCheckAvailability = this.onToggleCheckAvailability.bind(this);
    this.onToggleBookingSessionTimeoutWarning =
      this.onToggleBookingSessionTimeoutWarning.bind(this);
    this.onGoogleSignIn = this.onGoogleSignIn.bind(this);
    this.uuid = this.uuid.bind(this);
    this.onChangeAddOnsReservationSegmentId =
      this.onChangeAddOnsReservationSegmentId.bind(this);
    this.onSetGuestConfirmed = this.onSetGuestConfirmed.bind(this);
    this.onChangeSelectedEmoji = this.onChangeSelectedEmoji.bind(this);
    this.onChangeSelectedRating = this.onChangeSelectedRating.bind(this);
    this.onChangeFormField = this.onChangeFormField.bind(this);
    this.onSubmitGuestTypeCount = this.onSubmitGuestTypeCount.bind(this);
    this.onChangeFileUploadGroup = this.onChangeFileUploadGroup.bind(this);
    this.onGoToAccommodationsStep = this.onGoToAccommodationsStep.bind(this);
    this.onChangeAddress = this.onChangeAddress.bind(this);
    this.handlePlaceSelect = this.handlePlaceSelect.bind(this);
    this.onAddNewVoucher = this.onAddNewVoucher.bind(this);
    this.onRemoveNewVoucher = this.onRemoveNewVoucher.bind(this);
  }

  initCurrentCustomer() {
    var guest_information = this.props.current_customer;

    if (guest_information && Object.keys(guest_information).length) {
      var card_id = null;
      var card = null;
      if (this.props.cards && this.props.cards.length > 0) {
        for (var i = 0, ilen = this.props.cards.length; i < ilen; i++) {
          if (this.props.cards[i].default) {
            card = this.props.cards[i];
            card_id = card.id;
            break;
          }
        }

        guest_information.customer.cards = this.props.cards;
      }
      this.setState({
        card_id: card_id,
        payment_method: card || {},
        validPayment: card_id ? true : false,
        guest_information: guest_information.customer,
        guestSectionValid: true,
      });
    }
  }

  async componentDidMount() {
    this.setupWindowedCommunication();
    parent.window.postMessage("max-exp|mounted", "*");

    if (this.state.room_types && this.state.room_types.length > 0) {
      // we have room types, so do nothing
    } else {
      this.loadRoomTypes(
        this.state.start_date,
        this.state.end_date,
        null,
        this.state.step != "total"
      );
    }

    this.setupActivityMonitor();

    if (this.props.current_customer) {
      setTimeout(() => {
        this.initCurrentCustomer();
      }, 1);
    }
  }

  setupActivityMonitor() {
    var self = this;

    $(window).on("click.bookingflow keypress.bookingflow", function () {
      if (!self.state.session_interval) {
        self.setupSessionTimeout();
      }

      if (!self.state.session_timeout_warning_visible) {
        self.setState({
          session_start: new Date(),
          session_timeout_warning_visible: false,
        });
      }
    });
  }

  setupSessionTimeout() {
    var self = this;

    if (self.state.session_interval) {
      clearInterval(self.state.session_interval);
    }

    if (this.state.session_timeout_enabled === true) {
      var session_interval = setInterval(function () {
        var now = new Date();
        if (
          differenceInMilliseconds(now, self.state.session_start) >
          self.state.session_timeout_grace_period + self.state.session_timeout
        ) {
          self.expireSession();
        } else if (
          differenceInMilliseconds(now, self.state.session_start) >
          self.state.session_timeout
        ) {
          // session timeout!
          if (
            self.state.opened &&
            !self.state.session_timeout_warning_visible &&
            !self.state.session_expired
          ) {
            self.setState(
              { session_timeout_warning_visible: true },
              function () { }
            );
          } else if (!self.state.opened) {
            self.refreshSession();
          }
        }
      }, 1000);
    }

    this.setState({ session_interval: session_interval });
  }

  setupWindowedCommunication() {
    var self = this;
    var eventMethod = window.addEventListener
      ? "addEventListener"
      : "attachEvent";
    var eventer = window[eventMethod];
    var messageEvent = eventMethod == "attachEvent" ? "onmessage" : "message";

    // Listen to message from child window
    eventer(
      messageEvent,
      function (e) {
        if (
          e.data &&
          typeof e.data.split === "function" &&
          e.data.startsWith("max-exp")
        ) {
          var { [1]: msg_type, [2]: msg_body } = e.data.split("|");
          if (msg_type === "open") {
            self.setupSessionTimeout();
            self.loadRoomTypes(
              self.state.start_date,
              self.state.end_date,
              null
            );
            self.setState({
              session_expired: false,
              session_start: new Date(),
              opened: true,
            });
          } else if (msg_type === "close") {
            clearInterval(self.state.session_interval);

            var nextStep =
              (self.state.reservation_segments &&
                self.state.reservation_segments.length) ||
              (self.state.vouchers &&
                self.state.vouchers.length)
                ? self.state.step
                : "accommodations";
            if(self.state.step == "success"){
              self.onViewAccomidationsAfterBookingSuccessCallback();
            }else if (self.props.current_customer) {
              self.setState({ opened: false, step: nextStep });
            } else {
              self.setState(
                {
                  opened: false,
                  step: nextStep,
                  guestSectionValid: false,
                  guestSectionCustomerForm: null,
                  guest_information: {},
                  card_id: null,
                  validPayment: false,
                  sign_in_information: {},
                },
                () => {
                  self.onClearPaymentMethod();
                  $(window).trigger("resetBookingFlow");
                }
              );
            }
          }
        }
      },
      false
    );
  }

  componentWillUnmount() {
    clearInterval(this.state.session_interval);
  }

  /*** Render functions  ***/

  render() {
    // console.log("this.state.reservation_segments", this.state.reservation_segments);
    return (
      <div className="BookingFlow" ref={this.bookingFlowRef} style={{ overflow: this.state.modalVisible ? 'hidden' : 'auto' }}>
        {this.state.session_timeout_warning_visible ? (
          <ReactPortalsRoot
            children={[
              <ModalWarning
                key="body"
                title={I18n.t("session_timeout_warning")}
                body={
                  <SessionTimoutWarning
                    message={
                      this.props.session_timeout_warning_text ||
                      I18n.t("your_session_is_about_to_expire")
                    }
                  />
                }
                singleButtonLabel={I18n.t("continue")}
                onOK={() =>
                  this.setState({
                    session_start: new Date(),
                    session_timeout_warning_visible: false,
                    session_expired: false,
                  })
                }
                hideHeaderClose={true}
              />,
            ]}
            wrapperClassNames="ModalWarningWrapper"
          />
        ) : null}
        {this.state.session_expired ? (
          <ReactPortalsRoot
            children={[
              <ModalWarning
                key="body"
                title={I18n.t("session_expired")}
                body={
                  <SessionTimoutWarning
                    message={
                      this.props.session_timeout_confirmation_text ||
                      I18n.t("your_session_has_expired_to_restart")
                    }
                  />
                }
                singleButtonLabel={I18n.t("continue")}
                onOK={() => {
                  this.refreshSession();
                }}
                hideHeaderClose={true}
              />,
            ]}
            wrapperClassNames="ModalWarningWrapper"
          />
        ) : null}
        {this.props.ru_google_vr_landing ?<BookingFlowBrandingFooter {...this.props} /> : null}
        <div className={this.props.ru_google_vr_landing ? "BookingFlowWrapper branding-footer-space" : "BookingFlowWrapper"}>
          <BookingWizard
            {...this.props}
            vouchers={this.state.vouchers}
            step={this.state.step}
            current_customer={this.props.current_customer}
            sign_out_visible={this.props.sign_out_visible}
            products={this.props.products}
            onChange={this.onChangeStep}
            onRemoveVoucher={this.onRemoveNewVoucher}
            onSignOut={this.onSignOut}
            onToggleSignInSignUp={this.onToggleSignInSignUp}
            guest_information={this.state.guest_information}
            close_modal_button={this.props.close_modal_button}
            reservation_segments={this.state.reservation_segments}
            onViewAccomidationsAfterBookingSuccessCallback={
              this.onViewAccomidationsAfterBookingSuccessCallback
            }
            paymentErrors={this.state.paymentErrors}
          />

          {this.state.step == "accommodations" || this.state.step == "daily-rentals" ? (
            <BookingAccommodationsTab
              {...this.props}
              {...this.state}
              totalComponent={this.state.reservation_segments.length && this.state.add_ons_reservation_segment_id && this.state.loading == false  ? true : null}

              // totalComponent={this.state.add_ons.length || this.state.reservation_segments.length ? <div className="BookingTotal"><BookingFlowTotal {...this.state} {...this.props} /></div> : null}
              bookingFlowRef={this.bookingFlowRef}
              onAddReservationSegment={this.onAddReservationSegment}
              onChange={this.onChange}
              onRemoveVoucher={this.onRemoveNewVoucher}
              onChangeCurrency={this.onChangeCurrency}
              onChangeDates={this.onChangeDates}
              onGoogleSignIn={this.onGoogleSignIn}
              onChangeGuestTypeCount={this.onChangeGuestTypeCount}
              onModalVisible={this.onModalVisible}
              onSubmitGuestTypeCount={this.onSubmitGuestTypeCount}
              onSubmitPromoCode={this.onSubmitPromoCode}
              onToggleCheckAvailability={this.onToggleCheckAvailability}
              onChangeStartDate={this.onChangeStartDate}
            />
          ) : null}
          {this.state.step == "add-ons" ? (
            <BookingAddOnsTab
              {...this.props}
              {...this.state}
              reservation_segment_id={this.state.add_ons_reservation_segment_id}
              onChangeAddOns={this.onChangeAddOns}
              onChangeStep={this.onChangeStep}
              onRemoveVoucher={this.onRemoveNewVoucher}
              onChangeReservationSegmentId={
                this.onChangeAddOnsReservationSegmentId
              }
              onRemoveReservationSegment={this.onRemoveReservationSegment}
            />
          ) : null}
          {this.state.step == "vouchers" ? (
            <BookingVouchersTab
              {...this.props}
              {...this.state}
              onAddVoucher={this.onAddNewVoucher}
              onRemoveVoucher={this.onRemoveNewVoucher}
              onRemoveReservationSegment={this.onRemoveReservationSegment}
              onChangeAddOns={this.onChangeAddOns}
              onChangeStep={this.onChangeStep}
            />
          ) : null}
          {this.state.step == "total" ? (
            <BookingTotalTab
              {...this.props}
              {...this.state}
              onBookNow={this.onBookNow}
              onChange={this.onChange}
              onRemoveVoucher={this.onRemoveNewVoucher}
              onSetGuestInformation={this.onSetGuestInformation}
              onSetCardId={this.onSetCardId}
              onChangeCustomerForm={this.onChangeCustomerForm}
              onChangeGuestInformation={this.onChangeGuestInformation}
              onChangePaymentMethod={this.onChangePaymentMethod}
              onChangeSignInInformation={this.onChangeSignInInformation}
              onChangeStep={this.onChangeStep}
              onChangeFormField={this.onChangeFormField}
              onChangeSelectedEmoji={this.onChangeSelectedEmoji}
              onChangeSelectedRating={this.onChangeSelectedRating}
              onClearPaymentMethod={this.onClearPaymentMethod}
              onForgotPassword={this.onForgotPassword}
              onRemoveReservationSegment={this.onRemoveReservationSegment}
              onChangeGuestSectionValid={this.onChangeGuestSectionValid}
              onChangeCustomerFormFieldsValid={
                this.onChangeCustomerFormFieldsValid
              }
              onGoogleSignIn={this.onGoogleSignIn}
              onSignOut={this.onSignOut}
              onSetGuestConfirmed={this.onSetGuestConfirmed}
              paymentValid={this.paymentValid}
              clearSubStep={this.clearSubStep}
              clearPaymentErrors={this.clearPaymentErrors}
              setPaymentToken={this.setPaymentToken}
              getVoucher={this.getVoucher}
              onChangeVoucherInput={this.onChangeVoucherInput}
              removeVoucher={this.removeVoucher}
              toggleVoucherInput={this.toggleVoucherInput}
              onChangeFileUploadGroup={this.onChangeFileUploadGroup}
              handlePlaceSelect={this.handlePlaceSelect}
              onChangeAddress={this.onChangeAddress}
            />
          ) : null}
          {this.state.step == "success" ? (
            <BookingFlowSuccess
              {...this.props}
              {...this.state}
              {...this.state.reservation_success}
              reservation={this.state.reservation}
              vouchers={this.state.vouchers}
              onBookNow={this.onBookNow}
              onChange={this.onChange}
              onRemoveVoucher={this.onRemoveNewVoucher}
              onSetGuestInformation={this.onSetGuestInformation}
              onSetCardId={this.onSetCardId}
              onChangeCustomerForm={this.onChangeCustomerForm}
              onChangeGuestInformation={this.onChangeGuestInformation}
              onChangePaymentMethod={this.onChangePaymentMethod}
              onChangeSignInInformation={this.onChangeSignInInformation}
              onChangeStep={this.onChangeStep}
              onChangeAdditionalCustomerField={
                this.onChangeAdditionalCustomerField
              }
              onClearPaymentMethod={this.onClearPaymentMethod}
              onForgotPassword={this.onForgotPassword}
              onRemoveReservationSegment={this.onRemoveReservationSegment}
              onChangeGuestSectionValid={this.onChangeGuestSectionValid}
              onChangeCustomerFormFieldsValid={
                this.onChangeCustomerFormFieldsValid
              }
              onGoogleSignIn={this.onGoogleSignIn}
              onSignOut={this.onSignOut}
              onSetGuestConfirmed={this.onSetGuestConfirmed}
              handlePlaceSelect={this.handlePlaceSelect}
              onChangeAddress={this.onChangeAddress}
            />
          ) : null}
          {this.state.sign_in_sign_up_visible ? (
            <BookingSignInSignUpModal
              {...this.props}
              {...this.state}
              onRemoveVoucher={this.onRemoveNewVoucher}
              onSetGuestInformation={this.onSetGuestInformation}
              onSetCardId={this.onSetCardId}
              onChangeCustomerForm={this.onChangeCustomerForm}
              onChangeAdditionalCustomerField={
                this.onChangeAdditionalCustomerField
              }
              onChangeGuestInformation={this.onChangeGuestInformation}
              onChangeSignInInformation={this.onChangeSignInInformation}
              onForgotPassword={this.onForgotPassword}
              onSetErrors={this.onSetErrors}
              onSignOut={this.onSignOut}
              onChangeGuestSectionValid={this.onChangeGuestSectionValid}
              onChangeCustomerFormFieldsValid={
                this.onChangeCustomerFormFieldsValid
              }
              onToggleSignInSignUp={this.onToggleSignInSignUp}
              onGoogleSignIn={this.onGoogleSignIn}
              onSetGuestConfirmed={this.onSetGuestConfirmed}
              handlePlaceSelect={this.handlePlaceSelect}
              onChangeAddress={this.onChangeAddress}
            />
          ) : null}
          {this.state.check_availability_visible ? (
            <BookingCheckAvailabilityModal
              {...this.props}
              {...this.state}
              date={this.state.start_date}
              onRemoveVoucher={this.onRemoveNewVoucher}
              goToAccommodationsStep={this.goToAccommodationsStep}
              onToggleCheckAvailability={this.onToggleCheckAvailability}
              onAddReservationSegments={this.onAddReservationSegments}
              onChangeStartDate={this.onChangeStartDate}
              onGoToAccommodationsStep={this.onGoToAccommodationsStep}
            />
          ) : null}
          {this.state.loading && (
            <div className="overlay">
              <div className="loader">&nbsp;</div>
            </div>
          )}
        </div>
      </div>
    );
  }

  /**
   * Change handlers
   */

  paymentValid = (value) => {
    this.setState({ validPayment: value });
  };

  goToAccommodationsStep(dates) {
    var dates_arr = [];
    Object.values(dates).forEach(function (value, index) {
      dates_arr.push(value.date.date);
    });
    var min = dates_arr.reduce(function (a, b) {
      return a < b ? a : b;
    });
    var max = dates_arr.reduce(function (a, b) {
      return a > b ? a : b;
    });
    var start_date = DateHelper.parseRawDate(min);
    var end_date = DateHelper.parseRawDate(max);
    this.setState(
      {
        reservation_segments: [],
        taken_room_groups: [],
        check_availability_visible: false,
        step: "accommodations",
      },
      function () {
        this.loadRoomTypes(start_date, end_date, null, true);
      }
    );
  }

  onAddReservationSegments(room_types_and_dates, callbackFn) {
    const reservation_segments = [];

    const buildReservationSegment = (room_type, rate, start_date, end_date) => {
      const reservation_segment = {
        id: this.uuid(),
        room_type: room_type,
        rate: rate,
        start_date: start_date,
        end_date: end_date,
        guest_types: ObjectHelper.clone(this.state.guests),
      };
      return reservation_segment;
    };

    Object.keys(room_types_and_dates).forEach((key) => {
      const { dates: dates } = room_types_and_dates[key];
      const totalDates = dates.length - 1;
      const room_type = this.getRoomTypeById(key);
      const rate = this.getDefaultOrLowestRate(room_type);
      var reservationSegmentDates = [];
      var lastDate = null;
      dates
        .sort((a, b) => a - b)
        .every((date, idx) => {
          if (lastDate && differenceInDays(date, lastDate) > 1) {
            const reservation_segment = buildReservationSegment(
              room_type,
              rate,
              reservationSegmentDates[0],
              addDays(
                reservationSegmentDates[reservationSegmentDates.length - 1],
                1
              )
            );
            reservation_segments.push(reservation_segment);
            reservationSegmentDates = [];
          }
          if (idx === totalDates) {
            reservationSegmentDates.push(date);
            const reservation_segment = buildReservationSegment(
              room_type,
              rate,
              reservationSegmentDates[0],
              addDays(
                reservationSegmentDates[reservationSegmentDates.length - 1],
                1
              )
            );
            reservation_segments.push(reservation_segment);
            return false;
          }
          reservationSegmentDates.push(date);
          lastDate = date;
          return true;
        });
    });

    this.setState(
      {
        reservation_segments: reservation_segments,
        errors: [],
        loading: true,
      },
      () => {
        this.onBuildBooking(null, callbackFn);
      }
    );
  }

  onAddReservationSegment(room_type, rate, start_date, end_date, guests) {
    var self = this;
    var reservation_segments = this.state.reservation_segments && typeof this.state.reservation_segments.slice === 'function' ? this.state.reservation_segments.slice(0) : [];
    var reservation_segment = {
      id: this.uuid(),
      room_type: room_type,
      rate: rate,
      start_date: start_date,
      end_date: end_date,
      guest_types: ObjectHelper.clone(guests),
    };


    reservation_segments.push(reservation_segment);
    // console.log('reservation_segments', reservation_segments);

    this.setState(
      {
        reservation_segments: reservation_segments,
        taken_room_groups: [],
        errors: [],
        loading: true,
      },
      function () {
        self.onBuildBooking(reservation_segment.id);
      }
    );
  }

  onAddNewVoucher(amount, delivery_date, recipient_name, recipient_email, message) {
    var vouchers = this.state.vouchers.slice(0);
    var voucher = {
      id: this.uuid(),
      amount: amount,
      delivery_date: delivery_date,
      recipient_name: recipient_name,
      recipient_email: recipient_email,
      message: message
    };

    vouchers.push(voucher);

    sessionStorage.setItem(
      "vouchers",
      JSON.stringify(vouchers)
    );

    this.setState({ vouchers: vouchers, voucher_errors: [], loading: false, step: 'total' }, this.onBuildBooking);
  }

  onRemoveNewVoucher(index) {
    const vouchers = this.state.vouchers.slice(0);
    vouchers.splice(index, 1);

    sessionStorage.setItem(
      "vouchers",
      JSON.stringify(vouchers)
    );

    var step = this.state.step;
    if (vouchers.length) {
      step = 'total';
    } else if (vouchers.length === 0) {
      step = 'vouchers';
    }

    this.setState({ vouchers: vouchers, step: step }, this.onBuildBooking);
  }

  onBuildBooking(segmentTempID, callbackFn) {
    var self = this;
    var params = this.getBookingParams();
    params.accept_terms = true; // force this when building because guest has not seen final screen yet

    $.ajax({
      type: "POST",
      url: self.props.build_booking_path,
      data: params,
    }).done((data) => {
      var { reservation, vouchers } = data;
      if (reservation?.reservation_segments && reservation?.reservation_segments.length) {
        var reservation_segments = reservation.reservation_segments.map((seg) => {
          seg.id = seg.temp_id;
          seg.check_in_date = DateHelper.parseDateFromBackend(seg.check_in_date);
          seg.check_out_date = DateHelper.parseDateFromBackend(
            seg.check_out_date
          );

          if (segmentTempID && segmentTempID === seg.id) {
            window.dataLayer.push({ ecommerce: null });
            window.dataLayer.push({
              event: "add_to_cart",
              ecommerce: {
                items: [
                  {
                    item_name: seg.room_type.name,
                    item_id: seg.room_type.id,
                    price: (
                      (seg.total_amount - seg.taxes_amount) /
                      seg.number_of_nights /
                      100
                    ).toFixed(2),
                    item_category: "Room Nights",
                    item_category2: seg.rate.name,
                    item_variant: seg.rate.name,
                    quantity: seg.number_of_nights,
                  },
                ],
              },
            });
          }

          return seg;
        });

        var add_ons_reservation_segment_id =
          this.getAddOnsReservationSegmentId(reservation_segments);

        var add_on_products = [];
        reservation_segments.map((res_seg) => {
          if (res_seg.id == add_ons_reservation_segment_id) {
            add_on_products = res_seg.room_type.products;
          }
        });

        if (this.storageAvailable("sessionStorage")) {
          sessionStorage.setItem("reservation", JSON.stringify(reservation));
          sessionStorage.setItem(
            "reservation_segments",
            JSON.stringify(reservation_segments)
          );
          sessionStorage.setItem(
            "add_ons_reservation_segment_id",
            add_ons_reservation_segment_id
          );
        }
      }

      var step = self.getNextStep(reservation_segments)

      self.setState(
        {
          loading: false,
          step: step,
          check_availability_visible: false,
          reservation: reservation,
          reservation_segments: reservation_segments,
          reservation_segment_ids: reservation_segments && reservation_segments.length ? reservation_segments.map((seg) => seg.id) : [],
          add_ons_reservation_segment_id: add_ons_reservation_segment_id,
          add_on_products: add_on_products,
          vouchers: vouchers,
        },
        () => {
          if (step == "daily-rentals") {
            self.loadRoomTypes(self.state.start_date, self.state.end_date);
          }
          // if (typeof callbackFn === "function") {
          //   callbackFn();
          // }
        }
      );
    });
  }

  onBookNow(e) {
    var self = this;
    
    if (e && typeof e.preventDefault === "function") {
      e.preventDefault();
    }
    if (e && typeof e.stopPropagation === "function") {
      e.stopPropagation();
    }

    self.setState({ loading: true, errors: [] });

    $.ajax({
      type: "POST",
      url: this.props.create_booking_path,
      data: this.getBookingParams(),
    }).done((data) => {
      if (data && (data.errors || data.payment_errors)) {
        self.setState({ errors: data.errors, paymentErrors: data.payment_errors, loading: false });
        window.scrollTo(0, 0);
      } else if (data && data.success) {
        const { customer, reservation, vouchers } = data;
        const { reservation_segments } = reservation || [];

        if (self.storageAvailable("sessionStorage")) {
          sessionStorage.removeItem("guestSectionValid");
          sessionStorage.removeItem("guest_information");
          sessionStorage.removeItem("sign_in_information");
          sessionStorage.removeItem("card_id");
          sessionStorage.removeItem("reservation");
          sessionStorage.removeItem("reservation_segments");
          sessionStorage.removeItem("vouchers");
          sessionStorage.removeItem("add_ons");
        }

        window.dataLayer.push({ ecommerce: null });
        window.dataLayer.push({
          event: "purchase",
          ecommerce: {
            transaction_id: data.confirmation_number,
            affiliation: this.props.property.name,
            value: ((data.total_amount - data.taxes_amount) / 100).toFixed(2),
            tax: data.taxes_amount,
            currency: "USD",
            items: reservation_segments ? reservation_segments.map((resSeg) => {
              return {
                item_name: resSeg.room_type.name,
                item_id: resSeg.room_type.id,
                price: (
                  (resSeg.total_amount - resSeg.taxes_amount) /
                  resSeg.number_of_nights /
                  100
                ).toFixed(2),
                item_category: "Room Nights",
                item_category2: resSeg.rate.name,
                item_variant: resSeg.rate.name,
                quantity: resSeg.number_of_nights,
              };
            }) : null,
          },
        });

        self.setState(
          {
            errors: [],
            loading: false,
            customer: customer,
            taken_room_groups: [],
            step: "success",
            reservation: {},
            reservation_segments: [],
            confirmation_number: reservation ? reservation.confirmation_number : null,
            vouchers: [],
            success: {
              reservation: reservation,
              vouchers: vouchers,
              guest_information: self.state.guest_information,
              guest_confirmed: self.state.guest_confirmed,
              payment_method: self.state.payment_method,
              validPayment: this.state.validPayment,
              voucher: this.state.voucher,
              card_payment_amount: data.payed_today_details ? data.payed_today_details.card_payment_amount : null,
              voucher_payment_amount: data.payed_today_details ? data.payed_today_details.voucher_payment_amount : null,
            },
            voucher: null,
            voucherInputValue: null,
          },
          function () {
            self.loadRoomTypes(
              self.state.start_date,
              self.state.end_date,
              null,
              true
            );
          }
        );
        parent.window.postMessage(
          "max-exp|success|" +
          I18n.t("reservation_success", {
            confirmation_number: data.confirmation_number,
          }),
          "*"
        );
      }
    });
  }

  onChange(e, callback) {
    var value = e.target.type == "checkbox" ? e.target.checked : e.target.value;
    this.state[e.target.name] = value;
    this.setState(this.state, function () {
      if (typeof callback === "function") {
        callback();
      }
    });
  }

  onViewAccomidationsAfterBookingSuccessCallback = () => {
    this.setState({
      accept_terms: false,
      accept_communication_terms: true,
      source_type: this.props.source_type || "channel",
      source_id: this.props.source_id,
      marketing_opt_in: true,
      card_id: null,
      check_availability_visible: false,
      guestSectionValid: false,
      guestSectionCustomerForm: null,
      signInSignUpModalCustomerForm: null,
      validPayment: false,
      currency: {
        id: "USD|$|1",
        name: "United States Dollar",
        iso_code: "USD",
        symbol: "$",
        exchange_rate: 1,
      },
      date_format: this.props.date_format,
      errors: [],
      paymentErrors: [],
      guest_information: {},
      guest_confirmed: this.props.customer_confirmed,
      guests: this.getDefaultGuestTypes(),
      loading: false,
      opened: false,
      payment_method: {},
      voucher: null,
      displayVoucherInput: false,
      voucherInputValue: "",
      add_ons: [],
      add_ons_reservation_segment_id: "",
      promo_code: "",
      reservation: {},
      reservation_segments: [],
      reservation_segment_ids: [],
      room_types: this.props.room_types,
      session_start: new Date(),
      session_timeout: this.props.session_timeout_duration * 1000,
      session_timeout_grace_period: this.props.session_grace_period * 1000,
      session_timeout_enabled: this.props.session_timeout_enabled,
      session_timeout_warning_visible: false,
      session_expired_warning_visible: false,
      sign_in_information: {},
      sign_in_sign_up_visible: false,
      end_date: DateHelper.parseDateFromBackend(this.props.end_date),
      start_date: DateHelper.parseDateFromBackend(this.props.start_date),
      step: "accommodations",
      taken_room_groups: [],
      form_fields: this.props.form_fields || [],
      substep: null,
      reservationNotes: "",
    });
  };

  onChangeCustomerForm(form, name, callback) {
    this.state[name] = form;
    this.setState(this.state, function () {
      if (typeof callback === "function") {
        callback();
      }
    });
  }

  onChangeCurrency(val) {
    this.setState({
      currency: {
        id: val.id,
        name: val.text || val.name,
        iso_code: val.id.split("|")[0],
        symbol: val.id.split("|")[1],
        exchange_rate: parseFloat(val.id.split("|")[2]),
      },
    });
  }

  onChangeVoucherInput = (e) => {
    this.setState({ voucherInputValue: e.target.value });
  };

  onChangeStartDate(start_date, end_date) {
    var start_date = new Date(start_date);
    
    // Create a new Date object for end_date and set it to 1 day after start_date
    var end_date = new Date(start_date);
    end_date.setDate(end_date.getDate() + 1); // Adds 1 day to the start_date

    // this.setState({ check_availability_visible: false });

    this.onChangeDates(start_date, end_date);
  }

  onChangeDates(start_date, end_date) {
    var self = this;
    var taken_room_groups = [];
    if (this.storageAvailable("sessionStorage")) {
      sessionStorage.setItem(
        "dates",
        JSON.stringify({ start_date: start_date, end_date: end_date })
      );
    }
    this.setState(
      {
        start_date: new Date(start_date),
        end_date: new Date(end_date),
        taken_room_groups: taken_room_groups,
      },
      function () {
        if (start_date && end_date) {
          self.loadRoomTypes(start_date, end_date);
        } else {
          self.setState({
            room_type: [],
            loading: false,
          });
        }
      }
    );
  }

  onChangeAddOns(add_ons) {
    var self = this;
    if (this.storageAvailable("sessionStorage")) {
      sessionStorage.setItem("add_ons", JSON.stringify(add_ons));
    }
    this.setState({ add_ons: add_ons, loading: true }, function () {
      self.onBuildBooking();
    });
  }

  onChangeGuestTypeCount(e) {
    var guests = this.state.guests.slice(0);

    for (var i = 0, ilen = guests.length; i < ilen; i++) {
      if (e.target.name == guests[i].id) {
        guests[i].number_of_guests = parseInt(e.target.value);
      }
    }
    if (this.storageAvailable("sessionStorage")) {
      sessionStorage.setItem("guests", JSON.stringify(guests));
    }
    this.setState({ guests: guests });
  }

  onSubmitGuestTypeCount() {
    var self = this;
    self.loadRoomTypes(self.state.start_date, self.state.end_date);
  }

  onChangeGuestInformation(e) {
    this.state.guest_information[e.target.name] = e.target.value;

    this.setState({
      guest_information: this.state.guest_information,
      guestSectionValid: false,
    });
  }

  onChangePaymentMethod(e) {
    if (e.target.name == "save_card") {
      this.state.payment_method[e.target.name] = e.target.checked;
      this.setState({
        payment_method: this.state.payment_method,
        validPayment: false,
      });
    } else {
      this.state.payment_method[e.target.name] = e.target.value;
      this.setState({
        payment_method: this.state.payment_method,
        validPayment: false,
      });
    }
  }

  setPaymentToken = (token) => {
    var paymentMethod = _cloneDeep(this.state.payment_method);
    paymentMethod.payment_token = token;
    this.setState({ payment_method: paymentMethod, validPayment: true });
  };

  onChangeSignInInformation(e) {
    this.state.sign_in_information[e.target.name] = e.target.value;
    this.setState({ sign_in_information: this.state.sign_in_information });
  }

  onChangeGuestSectionValid(guestSectionValid) {
    this.setState({ guestSectionValid: guestSectionValid });
  }

  onChangeCustomerFormFieldsValid(customerFormFieldsValid) {
    this.setState({ customerFormFieldsValid: customerFormFieldsValid });
  }

  onChangeStep(step, callback) {
    
    var self = this;
    if (step == "daily-rentals") {
      
      this.setState({
        step: step,
        end_date: addDays(this.state.start_date, 1),
      }, () => {
        
        self.loadRoomTypes(self.state.start_date, self.state.end_date);
      })
    } else {
      this.setState({
        step: step
      }, () => {
      
        if (step == "accommodations") {
          self.loadRoomTypes(self.state.start_date, self.state.end_date);
        }
      })
    }
   

  }

  onChangeFormField(e) {
    var customer = this.state.guest_information;
    this.props.form_fields.map((field) => {
      if (field.id === e.target.id) {
        var found = false;
        if (customer.answers) {
          for (var i = 0, ilen = customer.answers.length; i < ilen; i++) {
            if (customer.answers[i].form_field_id === e.target.id) {
              found = true;
              break;
            }
          }
        }
        if (found) {
          customer.answers.map((answer) => {
            if (answer.form_field_id === e.target.id) {
              if (e.target.name == "number") {
                answer.number_answer = e.target.value;
              } else if (e.target.name == "date") {
                answer.date_answer = e.target.value;
              } else {
                answer.answer = e.target.value;
              }
            }
          });
        } else {
          if (!customer.answers) {
            customer.answers = [];
          }
          if (e.target.name == "number") {
            var new_answer = {
              form_field_id: e.target.id,
              number_answer: e.target.value,
            };
          } else if (e.target.name == "date") {
            var new_answer = {
              form_field_id: e.target.id,
              date_answer: e.target.value,
            };
          } else {
            var new_answer = {
              form_field_id: e.target.id,
              answer: e.target.value,
            };
          }

          customer.answers.push(new_answer);
        }
      }
    });

    this.setState({ guest_information: customer });
  }

  handlePlaceSelect(customer) {
    this.setState({
      guest_information: customer,
    });
  }

  onChangeAddress(form_field_id, e) {
    var customer = this.state.guest_information;
    this.props.form_fields.map((field) => {
      if (field.id === form_field_id) {
        var found = false;
        if (customer.answers) {
          for (var i = 0, ilen = customer.answers.length; i < ilen; i++) {
            if (customer.answers[i].form_field_id === form_field_id) {
              found = true;
              break;
            }
          }
        }
        if (found) {
          customer.answers.map((answer) => {
            if (answer.form_field_id === form_field_id) {
              answer.formatted_address = e.target.value;
            }
          });
        } else {
          if (!customer.answers) {
            customer.answers = [];
          }
          if (e.target.name == "answers[formatted_address]") {
            var new_answer = {
              form_field_id: form_field_id,
              formatted_address: e.target.value,
            };
          }
          customer.answers.push(new_answer);
        }
      }
    });
    this.setState({
      guest_information: customer,
      form_field_address_field_id: form_field_id,
    });
  }

  onChangeSelectedEmoji(emoji, form_field) {
    var answers = this.state.emoji_answers;

    this.props.form_fields.map((field) => {
      if (field.id === form_field.id) {
        var found = false;
        if (answers) {
          for (var i = 0, ilen = answers.length; i < ilen; i++) {
            if (answers[i].form_field_id === form_field.id) {
              found = true;
              break;
            }
          }
        }
        if (found) {
          answers.map((answer) => {
            if (answer.form_field_id === form_field.id) {
              answer.answer = emoji + "";
              answer.form_field_id = form_field.id;
              answer.form_field_type = form_field.field_type;
              answer.selected = !answer.selected;
            }
          });
        } else {
          if (!answers) {
            answers = [];
          }
          var new_answer = {
            answer: emoji + "",
            form_field_id: form_field.id,
            form_field_type: form_field.field_type,
            selected: true,
          };
          answers.push(new_answer);
        }
      }
    });

    this.setState({ emoji_answers: answers });
  }

  onChangeSelectedRating(rating, form_field) {
    var answers = this.state.rating_answers;

    this.props.form_fields.map((field) => {
      if (field.id === form_field.id) {
        var found = false;
        if (answers) {
          for (var i = 0, ilen = answers.length; i < ilen; i++) {
            if (answers[i].form_field_id === form_field.id) {
              found = true;
              break;
            }
          }
        }
        if (found) {
          answers.map((answer) => {
            if (answer.form_field_id === form_field.id) {
              answer.answer = rating + "";
              answer.form_field_id = form_field.id;
              answer.form_field_type = form_field.field_type;
              answer.selected = !answer.selected;
            }
          });
        } else {
          if (!answers) {
            answers = [];
          }
          var new_answer = {
            answer: rating + "",
            form_field_id: form_field.id,
            form_field_type: form_field.field_type,
            selected: true,
          };
          answers.push(new_answer);
        }
      }
    });

    this.setState({ rating_answers: answers });
  }

  onChangeFileUploadGroup(file_upload_group, form_field_id) {
    if (file_upload_group) {
      this.setState({
        file_upload_group: file_upload_group,
        customer_image_form_field_id: form_field_id,
      });
    }
  }

  onGoToAccommodationsStep(dates) {
    const start_date = dates[0];
    const room_type_id = dates[1];
    const end_date = addDays(start_date, this.props.default_number_nights);

    this.setState({
      loading: false,
      check_availability_visible: !this.state.check_availability_visible,
    });

    this.onChangeDates(start_date, end_date, room_type_id);
  }

  onSetErrors(errors) {
    this.setState({ errors: errors });
  }

  onToggleCheckAvailability(e) {
    if (
      typeof e.preventDefault === "function" &&
      typeof e.stopPropagation === "function"
    ) {
      e.preventDefault();
      e.stopPropagation();
    }

    this.setState({
      check_availability_visible: !this.state.check_availability_visible,
    });
  }

  onToggleBookingSessionTimeoutWarning(e) {
    if (
      typeof e.preventDefault === "function" &&
      typeof e.stopPropagation === "function"
    ) {
      e.preventDefault();
      e.stopPropagation();
    }

    this.setState({
      session_timeout_warning_visible: false,
      session_start: new Date(),
    });
  }

  onChangeAddOnsReservationSegmentId(reservation_segment_id) {
    var add_on_products = [];
    this.state.reservation_segments.map((res_seg) => {
      if (res_seg.id == reservation_segment_id) {
        add_on_products = res_seg.room_type.products;
      }
    });
    this.setState({
      add_ons_reservation_segment_id: reservation_segment_id,
      add_on_products: add_on_products,
    });
  }

  onClearPaymentMethod() {
    if (this.storageAvailable("sessionStorage")) {
      sessionStorage.removeItem("card_id");
    }
    this.setState({
      payment_method: { save_card: true },
      card_id: null,
      validPayment: false,
    });
  }

  onForgotPassword(e) {
    e.stopPropagation();
    e.preventDefault();

    var self = this;

    self.setState({ loading: true });

    $.ajax({
      type: "POST",
      url: this.props.customer_forgot_password_path,
      data: {
        email: self.state.sign_in_information.email,
        api_key: this.props.account.api_key,
        property: this.props.property.id,
        property_id: this.props.property.id,
      },
    }).done((data) => {
      self.setState({ loading: false });
    });
  }

  onModalVisible(visible) {
    $(this.bookingFlowRef.current).scrollTop(0);
    this.setState({ modalVisible: visible });
  }

  onRemoveReservationSegment(id) {
    var self = this;
    var room_group_id = null;
    var taken_room_groups = [...this.state.taken_room_groups];

    var reservation_segments = this.state.reservation_segments.slice(0);
    var idx = -1;

    for (var i = 0, ilen = reservation_segments.length; i < ilen; i++) {
      if (reservation_segments[i].id == id) {
        if (reservation_segments[i].room_group) {
          room_group_id = reservation_segments[i].room_group.id;
        }
        idx = i;
        break;
      }
    }

    if (room_group_id) {
      for (var k = 0, klen = taken_room_groups.length; k < klen; k++) {
        if (taken_room_groups[k] == room_group_id) {
          taken_room_groups.splice(k, 1);
          break;
        }
      }
    }

    if (idx >= 0) {
      window.dataLayer.push({ ecommerce: null });
      window.dataLayer.push({
        event: "remove_from_cart",
        ecommerce: {
          items: [
            {
              item_name: reservation_segments[idx].room_type.name,
              item_id: reservation_segments[idx].room_type.id,
              price:
                reservation_segments[idx].subtotal_amount /
                reservation_segments[idx].number_of_nights,
              item_category: "Room Nights",
              item_category2: reservation_segments[idx].rate.name,
              item_varian: reservation_segments[idx].rate.name,
              quantity: reservation_segments[idx].number_of_nights,
            },
          ],
        },
      });

      reservation_segments.splice(idx, 1);
    }

    if (reservation_segments && reservation_segments.length === 0) {
      if (this.storageAvailable("sessionStorage")) {
        sessionStorage.removeItem("reservation");
        sessionStorage.removeItem("reservation_segments");
        sessionStorage.removeItem("add_ons");
        sessionStorage.removeItem("add_ons_reservation_segment_id");
      }

      var step = this.state.step;
      if (this.state.vouchers && this.state.vouchers.length) {
        step = 'total';
      } else {
        step = 'accommodations';
      }

      this.setState(
        {
          reservation_segments: reservation_segments,
          step: step,
          add_ons_reservation_segment_id: "",
          reservation: {},
          add_ons: [],
          taken_room_groups: [],
        },
        function () {
          self.loadRoomTypes(self.state.start_date, self.state.end_date);
        }
      );
    } else {
      this.setState(
        {
          reservation_segments: reservation_segments,
          taken_room_groups: taken_room_groups,
          errors: [],
          loading: true,
        },
        function () {
          self.onBuildBooking();
        }
      );
    }
  }

  onSubmitPromoCode(e) {
    var self = this;

    if (e && e.stopPropagation && e.preventDefault) {
      e.stopPropagation();
      e.preventDefault();
    }

    self.loadRoomTypes(self.state.start_date, self.state.end_date);
  }

  onToggleSignInSignUp(e) {
    if (e && e.stopPropagation && e.preventDefault) {
      e.stopPropagation();
      e.preventDefault();
    }

    this.setState({
      sign_in_sign_up_visible: !this.state.sign_in_sign_up_visible,
      signInSignUpModalCustomerForm: null,
    });
  }

  onGoogleSignIn(data, callback) {
    var self = this;

    if (data && data.errors && data.errors.length > 0) {
      self.setState({
        loading: false,
        errors: data.errors,
        guestSectionValid: false,
      });
    } else {
      // get default card_id
      var card_id = null;
      if (data && data.cards && data.cards.length) {
        for (var i = 0, ilen = data.cards.length; i < ilen; i++) {
          if (data.cards[i].default) {
            card_id = data.cards[i].id;
            break;
          }
        }
      }

      data.email_confirmation = data.email;
      self.setState(
        {
          loading: false,
          errors: [],
          guest_information: data,
          card_id: card_id,
        },
        function () {
          if (typeof callback === "function") {
            callback();
          }
        }
      );
    }
  }

  onSetGuestInformation(guest_information) {
    this.setState({ guest_information: guest_information });
  }

  onSetCardId(card_id) {
    this.setState({ card_id: card_id, validPayment: card_id ? true : false });
  }

  onSignOut() {
    if (this.storageAvailable("sessionStorage")) {
      sessionStorage.removeItem("guest_information");
      sessionStorage.removeItem("sign_in_information");
      sessionStorage.removeItem("card_id");
      sessionStorage.removeItem("guestSectionValid", JSON.stringify(false));
    }
    this.setState({
      guest_information: {},
      sign_in_information: {},
      card_id: null,
      payment_method: {},
      voucher: null,
      displayVoucherInput: false,
      voucherInputValue: "",
      guestSectionCustomerForm: null,
      signInSignUpModalCustomerForm: null,
      guestSectionValid: false,
      validPayment: false,
    });
  }

  onSetGuestConfirmed(confirmed) {
    this.setState({ guest_confirmed: confirmed });
  }

  clearSubStep = () => {
    this.setState({ substep: null });
  };

  clearPaymentErrors = () => {
    this.setState({ paymentErrors: [] });
  };

  /**
   * Helper functions
   */

  buildReservationParams(bookReservationParams = false) {
    var params = {
      card_id: bookReservationParams ? _cloneDeep(this.state.card_id) : null,
      customer: Object.keys(this.state.guest_information).length && bookReservationParams
        ? _cloneDeep(this.state.guest_information)
        : null,
      payment_method: bookReservationParams ? _cloneDeep(this.state.payment_method) : null,
      reservation_segments: [],
      source_id: this.props.source_id,
      source_type: this.props.source_type,
      notes:
        this.state.reservationNotes && this.state.reservationNotes !== ""
          ? this.state.reservationNotes
          : null,
    };

    params.customer && bookReservationParams
    ? (params.customer.marketing_opt_in = this.state.marketing_opt_in)
    : null;

    var room_type_segments = {};

    if (this.state.reservation_segments && this.state.reservation_segments.length > 0) {
      this.state.reservation_segments.map((segment) => {
        if (
          segment.start_date < this.state.end_date &&
          segment.end_date > this.state.start_date
        ) {
          if (!segment.room && !segment.room_group) {
            room_type_segments[segment.room_type.id]
              ? (room_type_segments[segment.room_type.id] += 1)
              : (room_type_segments[segment.room_type.id] = 1);
          }
        }
      });

      params.room_type_segments = JSON.stringify(room_type_segments);

      for (
        var i = 0, ilen = this.state.reservation_segments.length;
        i < ilen;
        i++
      ) {
        var reservation_segment = this.state.reservation_segments[i];
        var add_ons = this.getAddOns(reservation_segment);
        params.reservation_segments.push({
          id: reservation_segment.id,
          add_ons: add_ons,
          rate_id: reservation_segment.rate.id,
          room_type: reservation_segment.room_type,
          check_in_date: reservation_segment.check_in_date
            ? reservation_segment.check_in_date
            : reservation_segment.start_date,
          check_out_date: reservation_segment.check_out_date
            ? reservation_segment.check_out_date
            : reservation_segment.end_date,

          room_group_id: reservation_segment.room_group
            ? reservation_segment.room_group.id
            : null,
          reservation_segment_guest_types:
            reservation_segment.reservation_segment_guest_types
              ? reservation_segment.reservation_segment_guest_types
              : reservation_segment.guest_types,
        });
      }

      return params;
    } else {
      return null;
    }
  }

  getAddOns(reservation_segment) {
    if (this.state.add_ons && this.state.add_ons[reservation_segment.id]) {
      return this.state.add_ons[reservation_segment.id];
    }
  }

  getAddOnsReservationSegmentId(reservation_segments) {
    if (reservation_segments && reservation_segments.length > 0) {
      return reservation_segments[reservation_segments.length - 1].id;
    } else {
      return "";
    }
  }

  getBookingParams() {
    var { guest_information: customer = {} } = this.state;
    customer.phone_number = customer.formatted_phone;
    delete customer.formatted_phone;

    return {
      account_id: this.state.account.id,
      property_id: this.state.property.id,
      api_key: this.state.account.api_key,
      customer: customer,
      accept_terms: this.state.accept_terms,
      accept_communication_terms: this.state.accept_communication_terms,
      card_id: this.state.card_id,
      currency: this.state.currency ? this.state.currency.iso_code : "USD",
      reservation: this.buildReservationParams(true),
      payment_method: _cloneDeep(this.state.payment_method),
      customer_answers: JSON.stringify(this.state.guest_information.answers),
      rating_answers: this.state.rating_answers ? JSON.stringify(this.state.rating_answers) : null,
      emoji_answers: this.state.emoji_answers ? JSON.stringify(this.state.emoji_answers) : null,
      customer_file_upload: this.state.file_upload_group,
      customer_image_form_field_id: this.state.customer_image_form_field_id,
      taken_room_groups: this.state.taken_room_groups,
      room_type_segments: this.roomTypeSegments(),
      items_source: this.props.call_source ? this.props.call_source : null,
      voucher_id: this.state.voucher ? this.state.voucher.id : null,
      vouchers: this.state.vouchers,
    }
  }

  getNextStep() {
    if(this.state.vouchers.length) {
      console.log('here')
      return 'total'
    }

    if (
      !this.state.reservation_segments ||
      (this.state.reservation_segments &&
        this.state.reservation_segments.length === 0)
    ) {
      // if there are ever no reservation_segments, then we need to go to accommodations
      return "accommodations";

    } 
    if (this.state.step === "accommodations" || this.state.step == "daily-rentals") {
      if (this.props.products && this.props.products.length > 0) {
        return "add-ons";
      } else {
        return "total";
      }
    } else {
      return this.state.step;
    }
  }

  loadRoomTypes(start_date, end_date, loading) {
    var self = this;
    var loading = typeof loading != "undefined" ? loading : true;

    var { reservation = {}, start_date, end_date } = this.state;
    var { reservation_segments = [] } = reservation;
    var [taken_room_types, taken_room_ids] =
      ReservationBuilderHelper.taken_room_types_and_ids(
        reservation_segments,
        start_date,
        end_date
      );

    let numberOfGuests = this.state.guests.reduce((acc, guestTypeObj) => {
      return (acc += parseInt(guestTypeObj.number_of_guests));
    }, 0);


    self.setState({ loading: loading });
    $.ajax({
      type: "POST",
      url: this.props.property_accommodations_path,
      data: {
        channel: "website",
        check_in_date: start_date,
        check_out_date: end_date,
        number_of_guests: numberOfGuests,
        locale: self.props.locale,
        taken_room_groups: self.state.taken_room_groups,
        promo_code: self.state.promo_code,
        account: this.props.account.id,
        property_id: this.props.property.id,
        api_key: this.props.account.api_key,
        taken_room_types: JSON.stringify(taken_room_types),
        taken_room_ids: JSON.stringify(taken_room_ids),
        number_of_guests: numberOfGuests,
        include_unavailable_rates: false,
        inquiry_room_type_id: this.props.inquiry_room_type_id, 
        type_of_booking: this.state.step == 'daily-rentals' ? 'daily' : null
      },
    }).done((data) => {

      self.setState({
        loading: false,
        room_types: data.room_types,
      });
    });
    
  }

  getDefaultGuestTypes() {
    var guest_types = [];

    for (
      var i = 0,
      ilen = this.props.guest_types.sort(
        (a, b) => a.position - b.position
      ).length;
      i < ilen;
      i++
    ) {
      var guest_type = { ...this.props.guest_types[i] };

      // first guest type is the default of 2 (or number of adults)
      if (i == 0) {
        guest_type.number_of_guests = this.props.adults || 2;
      } else {
        guest_type.number_of_guests = 0;
      }
      guest_types.push(guest_type);
    }

    return guest_types;
  }

  getDefaultOrLowestRate(room_type) {
    var lowest_rate = null;

    if (
      room_type &&
      room_type.available_rates &&
      room_type.available_rates.length
    ) {
      for (var i = 0, ilen = room_type.available_rates.length; i < ilen; i++) {
        if (
          !lowest_rate ||
          room_type.available_rates[i].default ||
          (room_type.available_rates[i].average_amount <
            lowest_rate.average_amount &&
            !lowest_rate.default)
        ) {
          lowest_rate = room_type.available_rates[i];
        }
      }
    }

    return lowest_rate;
  }

  count = 0;
  getNumberOfGuests() {
    for (var i = 0, ilen = this.state.guests.length; i < ilen; i++) {
      count = count + this.state.guests[i].number_of_guests;
    }
    return count;
  }

  getRoomTypeById(id) {
    for (var i = 0, ilen = this.state.room_types.length; i < ilen; i++) {
      if (this.state.room_types[i].id === id) {
        return this.state.room_types[i];
      }
    }
  }

  roomTypeSegments() {
    var room_type_segments = {};

    if (this.state.reservation_segments && this.state.reservation_segments.length > 0) {
      this.state.reservation_segments.map((segment) => {
        if (
          segment.start_date < this.state.end_date &&
          segment.end_date > this.state.start_date
        ) {
          if (!segment.room && !segment.room_group) {
            room_type_segments[segment.room_type.id]
              ? (room_type_segments[segment.room_type.id] += 1)
              : (room_type_segments[segment.room_type.id] = 1);
          }
        }
      });
    }

    return room_type_segments;
  }

  expireSession() {
    var self = this;

    this.setState({ session_expired_warning_visible: true });

    if (this.storageAvailable("sessionStorage")) {
      sessionStorage.removeItem("guest_information");
      sessionStorage.removeItem("sign_in_information");
      sessionStorage.removeItem("card_id");
      sessionStorage.removeItem("reservation");
      sessionStorage.removeItem("reservation_segments");
      sessionStorage.removeItem("add_ons");
      sessionStorage.removeItem("add_ons_reservation_segment_id");
    }

    clearInterval(self.state.session_interval);
    self.setState({
      card_id: null,
      validPayment: false,
      guestSectionValid: false,
      guest_information: {},
      sign_in_information: {},
      reservation: {},
      reservation_segments: [],
      step: self.state.step === "success" ? "success" : "accommodations",
      session_expired: true,
      session_interval: null,
      session_timeout_warning_visible: false,
      payment_method: {},
      voucher: null,
      voucherInputValue: "",
      displayVoucherInput: false,
      errors: [],
      paymentErrors: [],
    });
  }

  storageAvailable(type) {
    var storage;
    try {
      storage = window[type];
      var x = "__storage_test__";
      storage.setItem(x, x);
      storage.removeItem(x);
      return true;
    } catch (e) {
      return (
        e instanceof DOMException &&
        // everything except Firefox
        (e.code === 22 ||
          // Firefox
          e.code === 1014 ||
          // test name field too, because code might not be present
          // everything except Firefox
          e.name === "QuotaExceededError" ||
          // Firefox
          e.name === "NS_ERROR_DOM_QUOTA_REACHED") &&
        // acknowledge QuotaExceededError only if there's something already stored
        storage &&
        storage.length !== 0
      );
    }
  }

  refreshSession() {
    var self = this;

    if (this.storageAvailable("sessionStorage")) {
      sessionStorage.removeItem("guest_information");
      sessionStorage.removeItem("sign_in_information");
      sessionStorage.removeItem("card_id");
      sessionStorage.removeItem("reservation");
      sessionStorage.removeItem("reservation_segments");
      sessionStorage.removeItem("add_ons");
      sessionStorage.removeItem("add_ons_reservation_segment_id");
    }
    clearInterval(self.state.session_interval);

    if (isAfter(DateHelper.current(), this.state.start_date)) {
      var start_date = DateHelper.current();
      var end_date = addDays(DateHelper.current(), 1);
    } else {
      var start_date = this.state.start_date;
      var end_date = this.state.end_date;
    }

    self.setState(
      {
        session_start: new Date(),
        start_date: start_date,
        end_date: end_date,
        session_interval: null,
        session_timeout_warning_visible: false,
        session_expired: false,
        card_id: null,
        validPayment: false,
        guest_information: {},
        sign_in_information: {},
        reservation: {},
        reservation_segments: [],
        step: self.state.step === "success" ? "success" : "accommodations",
      },
      function () {
        self.loadRoomTypes(
          self.state.start_date,
          self.state.end_date,
          null,
          self.state.step != "total"
        );
        self.setupSessionTimeout();
      }
    );
  }

  removeVoucher = () => {
    this.setState({ voucher: null, displayVoucherInput: false, voucherInputValue: "", reservation_segments: [] });
  };

  toggleVoucherInput = () => {
    this.setState({ displayVoucherInput: !this.state.displayVoucherInput });
  };

  getVoucher = () => {
    this.setState({ loading: true });

    $.ajax({
      type: "POST",
      url: this.props.redeem_voucher_path,
      data: {
        account: this.props.account.id,
        property: this.props.property.id,
        property_id: this.props.property.id,
        api_key: this.props.account.api_key,
        voucher: {
          redemption_code: this.state.voucherInputValue,
        },
      },
    }).done((response) => {
      if (response.id) {
        this.setState({
          voucher: response,
          loading: false,
          voucherErrors: null,
        });
      } else if (response.errors) {
        this.setState({ voucherErrors: response.errors, loading: false });
      }
    });
  };

  uuid() {
    return "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(
      /[xy]/g,
      function (c) {
        var r = (Math.random() * 16) | 0,
          v = c == "x" ? r : (r & 0x3) | 0x8;
        return v.toString(16);
      }
    );
  }
}